import {ChatVehicleListEntry} from "../../chat/chat-vehicle-list.entry";

export class SendMessageEntry {

  constructor(public chatVehicleListEntry: ChatVehicleListEntry,
    public chatText: string,
    public file: any) {
  }

}
